import React from "react";
import styled, { keyframes } from "styled-components";

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const SkeletonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

const SkeletonCard = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  border-radius: 8px;
  padding: 20px;
  height: 200px;
  border: 1px solid #eee;
`;

const SkeletonLine = styled.div`
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 1000px 100%;
  animation: ${shimmer} 2s infinite;
  height: 14px;
  border-radius: 4px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }

  &.title {
    height: 18px;
    width: 60%;
    margin-bottom: 16px;
  }

  &.full-width {
    width: 100%;
  }

  &.short {
    width: 70%;
  }
`;

const AddressesSkeleton = ({ count = 3 }) => {
  return (
    <SkeletonContainer>
      {Array.from({ length: count }).map((_, idx) => (
        <SkeletonCard key={idx}>
          <SkeletonLine className="title" />
          <SkeletonLine className="full-width" />
          <SkeletonLine className="full-width" />
          <SkeletonLine className="short" />
        </SkeletonCard>
      ))}
    </SkeletonContainer>
  );
};

export default AddressesSkeleton;
